"use strict";
/**
 * AngularJS toolbar component controller.
 *
 * @packageDocumentation
 * @module Toolbar
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#region Util Imports
var lodash_es_1 = require("lodash-es");
//#endregion
var base_1 = require("../../components/base");
var IMRToolbarController = /** @class */ (function (_super) {
    tslib_1.__extends(IMRToolbarController, _super);
    function IMRToolbarController() {
        //#region Lifecycle
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        //#region Toolbar
        _this.toolbarOptions = null;
        _this.toolbar = null;
        return _this;
        //#endregion
    }
    IMRToolbarController.prototype.initialize = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.initializeToolbar()];
            });
        });
    };
    //#endregion
    //#region IIMRToolbar Implementation
    IMRToolbarController.prototype.getInnerToolbar = function () {
        return this.toolbar;
    };
    IMRToolbarController.prototype.initializeToolbar = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.prepareToolbarOptions();
                        return [4 /*yield*/, this.waitFormToolbarInitialized()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IMRToolbarController.prototype.prepareToolbarOptions = function () {
        var _a;
        this.toolbarOptions = (_a = lodash_es_1.cloneDeep(this.options.innerOptions)) !== null && _a !== void 0 ? _a : null;
        if (this.toolbarOptions == null) {
            this.toolbarOptions = {};
        }
        if (this.options.items !== undefined) {
            this.toolbarOptions.items = this.options.items;
        }
    };
    IMRToolbarController.prototype.waitFormToolbarInitialized = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var toolbarInitializedArgs;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.toolbarOptions != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, _super.prototype.waitForOnInitialized.call(this, this.toolbarOptions)];
                    case 1:
                        toolbarInitializedArgs = _b.sent();
                        this.toolbar = (_a = toolbarInitializedArgs.component) !== null && _a !== void 0 ? _a : null;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return IMRToolbarController;
}(base_1.IMRBaseComponentController));
exports.IMRToolbarController = IMRToolbarController;
//# sourceMappingURL=toolbar.controller.js.map